export default "__VITE_ASSET__8fd53267__"